import { useQuery } from '@tanstack/react-query';
// Service
import { getContent, getAllContents } from './contentService';

/**
 * @description useQuery Hook to get a content by its ID.
 * @param {string} contentId
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * Content, Error>}
 */
export const useGetContentQuery = (contentId, options) => useQuery({
  queryKey: ['content', contentId],
  queryFn: () => getContent(contentId),
  ...options,
});

/**
 * @description useQuery Hook to get all content.
 * @param {object} queryParams
 * @param {number} queryParams.pageNumber
 * @param {number} queryParams.pageSize
 * @param {string|null} [queryParams.contentTypeId]
 * @param {string|null} [queryParams.search]
 * @param {string|null} [queryParams.sort]
 * @param {ContentStatus|null} [queryParams.status]
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * {data: Content[], pagination: Pagination}, Error>}
 */
export const useGetAllContentsQuery = (queryParams, options) => useQuery({
  queryKey: ['allContents', queryParams],
  queryFn: () => getAllContents(queryParams),
  ...options,
});
